class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.onKeyUp = this.handleKeyUp.bind(this);

    this.querySelectorAll('[data-cart-notification-close]').forEach((closeButton) =>
      closeButton.addEventListener('click', () => this.close())
    );
    this.addEventListener('click', this.onCrossSellClick.bind(this));
  }

  onCrossSellClick(event) {
    const button = event.target.closest('[data-cart-notification-crosssell-add]');
    if (!button || !this.contains(button)) return;

    event.preventDefault();
    this.addCrossSellItem(button);
  }

  async addCrossSellItem(button) {
    if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;

    const variantId = button.dataset.variantId;
    const errorElement = document.getElementById(button.getAttribute('aria-describedby'));
    const crossSellItem = button.closest('.cart-notification-crosssell__item');
    const quantityInput = crossSellItem?.querySelector('[data-cart-notification-crosssell-quantity]');
    const quantity = Number.parseInt(quantityInput?.value || '1', 10);

    if (!variantId) {
      if (errorElement) {
        errorElement.textContent = '商品情報を取得できませんでした。';
        errorElement.hidden = false;
      }
      return;
    }

    if (!Number.isInteger(quantity) || quantity < 1 || (quantityInput && !quantityInput.checkValidity())) {
      if (errorElement) {
        errorElement.textContent = '数量を確認してください。';
        errorElement.hidden = false;
      }
      quantityInput?.focus();
      return;
    }

    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');
    button.querySelector('.loading__spinner')?.classList.remove('hidden');
    if (errorElement) errorElement.hidden = true;

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity);
    formData.append(
      'sections',
      this.getSectionsToRender().map((section) => section.id)
    );
    formData.append('sections_url', window.location.pathname);
    config.body = formData;

    this.setActiveElement(document.querySelector('#cart-icon-bubble') || button);

    try {
      const response = await fetch(`${routes.cart_add_url}`, config).then((result) => result.json());

      if (response.status) {
        throw new Error(response.description || response.message || 'カート追加に失敗しました。');
      }

      response.addedQuantity = quantity;

      await publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'cart-notification-cross-sell',
        productVariantId: variantId,
        cartData: response,
      });

      this.renderContents(response);
    } catch (error) {
      console.error('Cart notification cross-sell error:', error);

      if (errorElement) {
        errorElement.textContent = error.message || 'カート追加時にエラーが発生しました。';
        errorElement.hidden = false;
      }
    } finally {
      if (button.isConnected) {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
        button.classList.remove('loading');
        button.querySelector('.loading__spinner')?.classList.add('hidden');
      }
    }
  }

  open() {
    document.body.classList.add('cart-notification-open');
    this.notification.classList.add('animate', 'active');
    this.setAttribute('open', '');

    requestAnimationFrame(() => {
      this.notification.focus();
      trapFocus(this.notification);
    });

    document.body.addEventListener('click', this.onBodyClick);
    document.addEventListener('keyup', this.onKeyUp);
  }

  close() {
    this.notification.classList.remove('active');
    this.removeAttribute('open');
    document.body.classList.remove('cart-notification-open');
    document.body.removeEventListener('click', this.onBodyClick);
    document.removeEventListener('keyup', this.onKeyUp);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    const addedQuantity = this.querySelector('#cart-notification-added-quantity');
    if (addedQuantity) addedQuantity.textContent = parsedState.addedQuantity || 1;

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  handleKeyUp(evt) {
    if (evt.code === 'Escape') this.close();
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
